import Link from 'next/link';
import { FC } from 'react';

import { HeaderMenuLogo } from '../HeaderMenu/HeaderMenuLogo';

type Props = {
  href: string;
};

export const InvestorHeaderMenuLogoLink: FC<Props> = ({ href }) => {
  return (
    <Link href={href} className="flex items-center gap-4 no-underline outline-none">
      <div className="-mb-2 block h-18 w-30">
        <HeaderMenuLogo />
      </div>
      <p className="c-fs-body1 font-extrabold">Investor Centre</p>
    </Link>
  );
};
